import { Paperclip, Edit, Gift } from 'react-feather'
import { ReactElement } from 'react'
import { CartIcon } from 'src/lib/types/cartUI'
import { classNames } from 'src/lib/utils/helpers'

interface IconButton {
  id: CartIcon
  icon: ReactElement
  label: string
}

interface CartNotesIconProps {
  value: CartIcon
  onChange: (id: CartIcon) => void
}

const CartNotesIcon: React.FC<CartNotesIconProps> = ({ value, onChange }) => {
  const attachmentIcon = <Paperclip size={16} />
  const editIcon = <Edit size={16} />
  const giftIcon = <Gift size={16} />

  const buttons: IconButton[] = [
    { id: 'EDIT', icon: editIcon, label: 'Edit' },
    { id: 'ATTACH', icon: attachmentIcon, label: 'Attach File' },
    { id: 'GIFT', icon: giftIcon, label: 'Gift' }
  ]

  return (
    <div className='flex gap-4 pb-4'>
      {buttons.map(({ id, icon, label }) => (
        <div
          className={classNames(
            `p-3 rounded-xl bg-gray-light cursor-pointer border-2`,
            value === id ? 'bg-teal-100 border-teal-500' : ''
          )}
          key={id}
          onClick={() => onChange(id)}
        >
          <button aria-label={label} className='p-2 rounded-xl border-1 border-coal-lighter bg-white'>
            <span className='text-coal-dark'>{icon}</span>
          </button>
        </div>
      ))}
    </div>
  )
}

export default CartNotesIcon
